import React from 'react';
import { Filters } from 'src/components/Filters';
import {
  FiltersConfig,
  FilterType,
  Groups,
} from 'src/components/Filters/types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useMemo } from 'react';
import { RootState } from 'src/store';
import { vendorsOptions } from 'src/routes/Dashboard/store/services/mockData';
import {
  getInboxViewFiltersData,
  inboxViewResetControlFilters,
  inboxViewSetControlFilters,
} from 'src/routes/Inbox/store/inboxViewSlice';
import { InboxControlFilter } from 'src/routes/Inbox/store/inboxViewSlice/types';

type OwnProps = {
  isDisabled?: boolean;
};

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  OwnProps;

const InboxFilters: React.FC<Props> = ({
  isDisabled = false,
  filtersState,
  setFiltersControls,
  resetFilters,
}) => {
  const filters: FiltersConfig<InboxControlFilter> = useMemo(
    () => ({
      main: [
        {
          field: 'freeText',
          label: '',
          type: FilterType.TextInput,
          groupBy: Groups.Category,
        },
      ],
    }),
    [vendorsOptions],
  );

  const initialValues = useMemo<any>(() => ({}), [filtersState]);

  const valuesResetTo = useMemo<any>(() => ({}), []);

  return (
    <Filters<InboxControlFilter>
      formIsSubmittedOnFieldChange
      isDisabled={isDisabled}
      filtersConfig={filters}
      initialValues={initialValues}
      valuesResetTo={valuesResetTo}
      onSubmit={setFiltersControls}
      onResetFilters={resetFilters}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  filtersState: getInboxViewFiltersData(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setFiltersControls: (payload: any) =>
    dispatch(inboxViewSetControlFilters(payload)),
  resetFilters: () => dispatch(inboxViewResetControlFilters()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InboxFilters);
